
import React, { useEffect } from "react";
import TocFotosHeader from "@/components/TocFotosHeader";
import TocFotosHero from "@/components/TocFotosHero";
import TocFotosSteps from "@/components/TocFotosSteps";
import TocFotosGallery from "@/components/TocFotosGallery";
import TocFotosTestimonials from "@/components/TocFotosTestimonials";
import TocFotosCTA from "@/components/TocFotosCTA";
import TocFotosContactForm from "@/components/TocFotosContactForm";
import TocFotosFooter from "@/components/TocFotosFooter";

import TocFotosStickyCTA from "@/components/TocFotosStickyCTA";
import { isBrowser } from "@/utils/runtime";

const TocFotos01 = () => {
  // Set page title for SEO
  useEffect(() => {
    if (!isBrowser) return;
    globalThis.document.title = "Toc Fotos | Fotografia Profissional para Imóveis | Toc Toc";
    // Add meta description dynamically
    const metaDescription = globalThis.document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content",
        "Serviços de fotografia profissional para seu imóvel. Agende sua sessão e obtenha imagens que destacam o potencial do seu espaço.");
    }

    // Add favicon
    let link = globalThis.document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (!link) {
      link = globalThis.document.createElement('link');
      link.rel = 'icon';
      globalThis.document.head.appendChild(link);
    }
    link.href = '/lovable-uploads/d19e038d-29d8-4cd9-a79d-18df10ce0f07.png';
  }, []);
  
  const scrollToContact = () => {
    if (isBrowser) {
      const contactSection = globalThis.document.getElementById("contato");
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  // Sample gallery images data
  const galleryImages = [
    {
      url: "/lovable-uploads/5d0bfcd5-8f46-490c-8e19-f0153b1a59b3.png",
      type: "image" as const
    },
    {
      url: "/lovable-uploads/9d9dee7d-2850-451a-9469-91caabdf7f0c.png",
      type: "image" as const
    },
    {
      url: "/lovable-uploads/cbb23aa4-bf2c-4d20-8c67-3e50fed861a3.png",
      type: "image" as const
    },
    {
      url: "/lovable-uploads/e4405c79-3173-4e9c-81d5-25973e61413d.png",
      type: "image" as const
    }
  ];

  return (
    <div className="min-h-screen flex flex-col bg-white font-sans">
      <TocFotosHeader />
      <main>
        {/* Hero section with main message */}
        <section id="inicio">
          <TocFotosHero />
        </section>
        
        {/* Process steps section */}
        <section id="como-funciona" className="py-16 md:py-24 bg-white">
          <TocFotosSteps />
        </section>
        
        {/* Gallery section */}
        <section id="galeria" className="py-16 md:py-24 bg-gray-50">
          <TocFotosGallery 
            title="Galeria de Fotos Profissionais"
            description="Confira exemplos de nossos trabalhos de fotografia profissional para imóveis"
            images={galleryImages}
          />
        </section>
        
        {/* Testimonials section */}
        <section id="depoimentos" className="py-16 md:py-24 bg-white">
          <TocFotosTestimonials />
        </section>
        
        {/* Call to action section */}
        <section id="cta" className="py-16 md:py-20 bg-[#3332FC] text-white">
          <TocFotosCTA onButtonClick={scrollToContact} />
        </section>
        
        {/* Contact form section */}
        <section id="contato" className="py-16 md:py-24 bg-white">
          <TocFotosContactForm />
        </section>
      </main>
      <TocFotosFooter />
      <TocFotosStickyCTA onButtonClick={scrollToContact} />
    </div>
  );
};

export default TocFotos01;
